module.exports = __webpack_public_path__ + "img/吴茱萸.d1aee0cd.jpg";